import CityPageTemplate from "../city-template/CityPageTemplate";
import { williamsburgVaConfig } from "./data";

export default function WilliamsburgVaPage() {
  return <CityPageTemplate config={williamsburgVaConfig} />;
}